import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


// Todo: Add page specific JS here e.g:
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as filter from "./scripts/filter.js";
filter.init();

import * as affix from './scripts/elements-packages/affix';
affix.init({mediaQuery: '(min-width: 1100px)'});

import * as restaurantHotspot from "./scripts/hotspot-map.js";
restaurantHotspot.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init();

import * as eventCardTeaserSlider from './scripts/event-card-teaser-slider';
eventCardTeaserSlider.init();

import * as allergeneScrollTo from './scripts/allergene-scroll-to';
allergeneScrollTo.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as mixedCardTeaserSlider from './scripts/mixed-card-teaser-slider';
mixedCardTeaserSlider.init();

import * as imgTeaserRowSlider from './scripts/img-teaser-row-slider';
imgTeaserRowSlider.init();

import * as video from './scripts/video';
video.init();

import * as lightbox from '@elements/lightbox';
lightbox.init({
        plugins: ['zoom', 'video'],
        zoom: true,
        video: true
    }
);